import { defineAction } from '~/prix'
import llmChatMessageCreateAction from './llmChatMessageCreate.action.json' assert { type: 'json' }
import { z } from 'zod'

const llmChatMessageCreateDefinition = defineAction({
  ...llmChatMessageCreateAction,

  input: z.object({
    chatId: z.number(),
    message: z.object({
      id: z.string(),
      createdAt: z.string(),
      role: z.enum(['user', 'assistant', 'system', 'data']),
      content: z.string(),
    }),
  }),
  output: z.object({
    // Para streaming, a resposta real vai pelo stream
    success: z.boolean().optional(),
  }),
})

export default llmChatMessageCreateDefinition
